import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import { CreateStatusType } from '@state/utils/models';
import { Observable } from 'rxjs';
import { MatterDispatch } from '@state/matter';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { Brokerage, MatterFileType } from '@models/matter';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationService } from 'src/app/shared/services/nav/nav.service';
import { isEqual } from 'lodash';

@UntilDestroy()
@Component({
	selector: 'app-edit-brokerage-side-form',
	templateUrl: './edit-brokerage-side-form.component.html',
	standalone: false,
})
export class EditBrokerageSideFormComponent implements OnInit {
	@Input() name;
	public isClient;
	@Input() createStatusType = CreateStatusType;
	public brokerage: Brokerage;

	@SelectSnapshot(SelectedMatter.id) saleId;
	@Select(SelectedMatter.clientBrokerage)
	clientBrokerage$: Observable<Brokerage>;
	@SelectSnapshot(SelectedMatter.matterFileType) fileType: MatterFileType;

	constructor(
		private matterDispatch: MatterDispatch,
		private router: Router,
		private route: ActivatedRoute,
		private navigationService: NavigationService,
	) {
		const data = this.router.getCurrentNavigation()?.extras?.state?.data;
		if (data) {
			this.brokerage = data.brokerage;
			this.isClient = data.isClient;
		} else {
			this.navigationService.goBack(this.route);
		}
	}

	ngOnInit() {}

	createBrokerage = (brokerage: Brokerage) =>
		this.matterDispatch.CreateBrokerage(
			this.saleId,
			brokerage,
			this.isClient,
			this.fileType,
		);

	onSubmit(event) {
		if (!isEqual(this.brokerage, event)) {
			this.createBrokerage(event);
		}

		this.navigationService.goBack(this.route);
	}

	title() {
		if (this.isClient) {
			return this.fileType === MatterFileType.SALE
				? 'Seller'
				: this.fileType === MatterFileType.PURCHASE
					? 'Buyer'
					: '';
		}

		return this.fileType === MatterFileType.SALE
			? 'Buyer'
			: this.fileType === MatterFileType.PURCHASE
				? 'Seller'
				: '';
	}

	onCancel() {
		this.navigationService.goBack(this.route);
	}
}
